import axios from 'axios';

export const allServices = () =>
  axios
    .post('/api/ds-service', { op: 'list' })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const createService = values =>
  axios
    .post('/api/ds-service', {
      op: 'create',
      item: values,
    })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const getService = id =>
  axios
    .post('/api/ds-service', {
      op: 'read',
      convert: true,
      item: {
        id: id,
      },
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const deleteService = id =>
  axios
    .post('/api/ds-service', { op: 'delete', item: { id } })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const updateService = data =>
  axios
    .post('/api/ds-service', { op: 'update', item: data })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/services/_api.js